import {
    FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_BEGIN,
    FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_SUCCESS,
    FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_FAILURE,
    PENDING_CASE_BEGIN,
    PENDING_CASE_SUCCESS,
    PENDING_CASE_FAILURE,
    FORMER_CUSTOMER_CREATE_CASE_BEGIN,
    FORMER_CUSTOMER_CREATE_CASE_SUCCESS,
    FORMER_CUSTOMER_CREATE_CASE_FAILURE,
    FORMER_CUSTOMER_ADDRESS_DOB_BEGIN,
    FORMER_CUSTOMER_ADDRESS_DOB_SUCCESS,
    FORMER_CUSTOMER_ADDRESS_DOB_FAILURE,
    CREATE_UUID_BEGIN,
    CREATE_UUID_SUCCESS,
    CREATE_UUID_FAILURE,
    CREATE_TIME_FRAME_BEGIN,
    CREATE_TIME_FRAME_SUCCESS,
    CREATE_TIME_FRAME_FAILURE,
    CREATE_FILE_FORMAT_BEGIN,
    CREATE_FILE_FORMAT_SUCCESS,
    CREATE_FILE_FORMAT_FAILURE,
    FORMER_DOC_VERIFICATION_BEGIN,
    FORMER_DOC_VERIFICATION_SUCCESS,
    FORMER_DOC_VERIFICATION_FAILURE,
    FORMER_VALIDATE_SECURE_PIN_BEGIN,
    FORMER_VALIDATE_SECURE_PIN_SUCCESS,
    FORMER_VALIDATE_SECURE_PIN_FAILURE,
    CLOSE_CASEID_BEGIN,
    CLOSE_CASEID_SUCCESS,
    CLOSE_CASEID_FAILURE,
    BREADCRUMBS_LINK_BEGIN,
    BREADCRUMBS_LINK_SUCCESS,
    BREADCRUMBS_LINK_FAILURE,
} from "./types";

import { GENERIC_ERROR_MESSAGE } from "../../DownloadAndDelete/actions/types";
import API from "../../../../../Services/API";
import { encryptData } from "utils/decryptData";
import { ENDPOINTS } from "utils/endpoints";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkAMLob } from "utils/checkAMLob";

export const checkPendingCases = (email, intent, DeleteisOptOut, serviceType, accountId, txnId, checkUser,checkMtn) => async dispatch => {

    dispatch({ type: PENDING_CASE_BEGIN });
    const processStep = "CheckPendingCase"
    let dataToAPI;
    
    if(checkUser === undefined){

     if (intent === "DeleteAccount") {
        dataToAPI = {
            intent,
            processStep,
            accountId,
        };
    } else if (serviceType === "former") {
        if (intent === "Delete") {
            dataToAPI = {
                email,
                intent,
                isOptOut: DeleteisOptOut,
                processStep,
                serviceType
            };
        } else if (intent === "Download" || intent === "Correct") {
            dataToAPI = {
                email,
                intent,
                processStep,
                serviceType
            };
        }
    } else if (serviceType === "guest") {
        if (intent === "Delete") {
            dataToAPI = {
                email,
                intent: "DeleteOpt",
                processStep,
                serviceType
            };
        } else if (intent === "Download") {
            dataToAPI = {
                email,
                intent,
                processStep,
                serviceType
            };
        }
    } else if (serviceType === "vzw-former" || serviceType === "vzt-former") {
        dataToAPI = {
            email,
            intent,
            processStep,
            serviceType,
            txnId
        };
    }
    

  } 
  //Agent flow 
  else if(checkAMLob()==="agent"){
    dataToAPI={
        "intent": "ResidencyProof", 
        "processStep": "CheckPendingCase",
        "identifier": "mtn",
        "value":checkMtn
    }
  }
  else {

     //Active USer flow
     dataToAPI = {
        "intent": "ResidencyProof", 
        "processStep": "CheckPendingCase"
     };
    
  }
   
     
  

    try {

        let url ;
        if(checkUser === undefined){
            url =  ENDPOINTS.FORMER_DOWNLOAD_PENDING_CASE;   
           
        }else if(checkUser==="agent"){
            //Agent 
            url=ENDPOINTS.AGENT_CHECK_PENDING_CASE;
        }else {
            
            //Active Customer
           url = ENDPOINTS.ACTIVE_CUSTOMER_CHECK_PENDING_CASE;
        }

        const response = await API({
            url: url,
            method: "POST",
            data: dataToAPI
        });

        if (response && response.status === "OK") {
            const payload = {
                ...response.data
            };
            if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context && response.data.serviceBody.serviceResponse.context.isCasePending) {
                payload.isCasePending = response.data.serviceBody.serviceResponse.context.isCasePending === "True" ? true : false;
            }
            if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context && response.data.serviceBody.serviceResponse.context.caseId) {
                payload.caseId = response.data.serviceBody.serviceResponse.context.caseId;
            }
            dispatch({
                type: PENDING_CASE_SUCCESS,
                payload
            });
        } else {
            dispatch({ type: PENDING_CASE_FAILURE, payload: GENERIC_ERROR_MESSAGE });
        }
    } catch (error) {
        if (error.response && error.response.hasOwnProperty("description")) {
            dispatch({
                type: PENDING_CASE_FAILURE,
                payload: error.response.description
            });
        } else {
            dispatch({
                type: PENDING_CASE_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    }
};

export const createUpdateProfile = (data, checkUser,checkMtn) => async dispatch => {
    dispatch({ type: FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_BEGIN });

    let isCreateProfile ='';
    let isBillingUpdate = '';
    let isTimeFrameSelection = '';
    let isFileFormatSelection = '';

    var emailId ;
    var startDate ;
    var endDate ;
    var fileFormat ;
    var firstName ;
    var lastName ;
    var streetAddress ;
    var aptOrSuiteOrFloor ;
    var zipCode  ;
    var city  ;
    var state ;
    var action ;
    var serviceType ;

    var isOptOut;

    if(checkUser === undefined){ 
           
     isCreateProfile = "createProfile" === data.flow ? "Y" : "N";
     isBillingUpdate = "billingUpdate" === data.flow ? "Y" : "N";
     isTimeFrameSelection = "timeFrameSelection" === data.flow ? "Y" : "N";
     isFileFormatSelection = "fileFormatSelection" === data.flow ? "Y" : "N";

     emailId = data.emailId ? data.emailId : null;
     startDate = data.startDate ? data.startDate : null;
     endDate = data.endDate ? data.endDate : null;
     fileFormat = data.fileFormat ? data.fileFormat : null;
     firstName = data.firstName ? data.firstName : null;
     lastName = data.lastName ? data.lastName : null;
     streetAddress = data.streetAddress ? data.streetAddress : null;
     aptOrSuiteOrFloor = data.aptOrSuiteOrFloor ? data.aptOrSuiteOrFloor : null;
     zipCode = data.zipCode ? data.zipCode : null;
     city = data.city ? data.city : null;
     state = data.state ? data.state : null;
     action = data.action ? data.action : null;
     serviceType = data.serviceType ? data.serviceType : null;


   

    if (data.isOptOut === "Y") {
        isOptOut = data.isOptOut
    } else if (serviceType === "guest" && action === "delete") {
        isOptOut = "Y"
    } else {
        isOptOut = "N"
    }

    }else{
     

    }



    var uuid = null
    var accountIds = null

    if (serviceType === "former" && data.formerId) {
        uuid = data.formerId ? data.formerId : null;

        if (data.accountId && data.accountId.length > 0) {
            accountIds = Array.prototype.map.call(data.accountId, function (item) { return item.accountId; }).join(",")
        }

    } else {
        uuid = data.uuid ? data.uuid : null;
    }

    try {

        let url, datas;

        if(checkUser === undefined){

            url = ENDPOINTS.FORMER_DOWNLOAD_CREATE_UPDATE_PROFILE;
            datas = {
                    isCreateProfile,
                    isBillingUpdate,
                    isTimeFrameSelection,
                    isFileFormatSelection,
                    emailId,
                    startDate,
                    endDate,
                    fileFormat,
                    firstName,
                    lastName,
                    streetAddress,
                    aptOrSuiteOrFloor,
                    zipCode,
                    city,
                    state,
                    action,
                    uuid,
                    isOptOut,
                    serviceType,
                    accountIds
                
            }

           
        
        }
        //Agent flow
        else if(checkUser==="agent"){
            url=ENDPOINTS.AGENT_CREATE_PROFILE;
            datas={
                "intent": "ResidencyProof", 
                "processStep": "CreateProfile",
                "identifier": "mtn",
                "value": checkMtn
            }
        }
            else{
            
            url = ENDPOINTS.ACTIVE_CUSTOMER_CREATE_PROFILE;
           datas ={
             "intent": "ResidencyProof", 
            "processStep": "CreateProfile"
           }
            
        }

        const response = await API({
            url:  url,
            method: "POST",
            data: datas
        });


        if (response && response.status === "OK") {

           if(checkUser === undefined){

            dispatch({
                type: FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_SUCCESS,
                payload: response.data
            });

           }
           //Agent
           else if(checkUser==="agent"){
            const payload = {
                ...response.data
            };


            if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context && response.data.serviceBody.serviceResponse.context.caseId) {
                payload.caseId = response.data.serviceBody.serviceResponse.context.caseId;
            }
            
            dispatch({
                type: FORMER_CUSTOMER_CREATE_CASE_SUCCESS,
                payload
            });

           }
           else{

             /* Active Customer */

            const payload = {
                ...response.data
            };


            if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context && response.data.serviceBody.serviceResponse.context.caseId) {
                payload.caseId = response.data.serviceBody.serviceResponse.context.caseId;
            }
            
            dispatch({
                type: FORMER_CUSTOMER_CREATE_CASE_SUCCESS,
                payload
            });
           //

           }
            
            
           

        } else {
            
            dispatch({ type: FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_FAILURE, payload: GENERIC_ERROR_MESSAGE });
        }
    } catch (error) {
        if (error.response && error.response.hasOwnProperty("description")) {
            dispatch({
                type: FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_FAILURE,
                payload: error.response.description
            });
        } else {
            dispatch({
                type: FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    }
};

export const createCase = (email, profileId, FirstName, lastName, intent, isOptOut, serviceType,
    mtn, accountId, address, role, state, appealType, checkUser,checkMtn) => async (dispatch, getState) => {
        dispatch({ type: FORMER_CUSTOMER_CREATE_CASE_BEGIN });
        var processStep = "CreateProfile";

        try {

            let dataToAPI; 
            let url;

           if(checkUser === undefined){

            if (serviceType === "former") {
                if (intent === "DeleteAccount") {
                    dataToAPI = {
                        email,
                        accountId,
                        profileId,
                        FirstName,
                        lastName,
                        intent,
                        processStep,
                        addressLine1: address && address.addressLine1 ? address.addressLine1 : null,
                        city: address && address.city ? address.city : null,
                        state: address && address.state ? address.state : null,
                        zipCode: address && address.zipCode ? address.zipCode : null,
                        serviceType
                    }
                }
                else if (intent === "Delete") {
                    if (isOptOut === "Y") {
                        dataToAPI = {
                            email,
                            profileId,
                            FirstName,
                            lastName,
                            intent,
                            processStep,
                            serviceType,
                            isOptOut,
                            mtn
                        };
                    } else {
                        dataToAPI = {
                            email,
                            profileId,
                            FirstName,
                            lastName,
                            intent,
                            processStep,
                            serviceType,
                            isOptOut
                        };
                    }

                } else if (intent === "Download" || intent === "Correct") {
                    dataToAPI = {
                        email,
                        profileId,
                        FirstName,
                        lastName,
                        intent,
                        processStep: "CreateProfile",
                        serviceType
                    };
                }
            } else if (serviceType === "guest") {
                if (intent === "Delete") {
                    dataToAPI = {
                        email,
                        profileId,
                        intent: "DeleteOpt",
                        processStep,
                        serviceType,
                        mtn
                    };
                } else if (intent === "Download") {
                    dataToAPI = {
                        email,
                        profileId,
                        intent,
                        processStep: "CreateProfile",
                        serviceType,
                        mtn
                    };
                }
            } else if (serviceType === "vzw-former" || serviceType === "vzt-former") {
                if (checkNestedObject(getState(), "form", "appealForm", "values")) {
                    const {
                        appealReason,
                        appealReasonOther,
                    } = getState().form.appealForm.values;

                    dataToAPI = {
                        email,
                        txnId: profileId,
                        intent,
                        processStep: "CreateProfile",
                        serviceType,
                        accountId,
                        appealReason,
                        appealReasonOther,
                        appealType,
                        role,
                        state
                    };
                }
            }
            url = ENDPOINTS.FORMER_DOWNLOAD_CREATE_CASE;

         }
         //Agent flow
         else if(checkUser==="agent"){
            dataToAPI = {
                "intent": "ResidencyProof", 
                "processStep": "CreateProfile",
                "identifier": "mtn",
                "value": checkMtn
             };

             url = ENDPOINTS.AGENT_CREATE_PROFILE;
         }else {

            dataToAPI = {
                "intent": "ResidencyProof", 
                "processStep": "CreateProfile"
             };

             url = ENDPOINTS.ACTIVE_CUSTOMER_CREATE_PROFILE;

            
        }


            const response = await API({
                url: url,
                method: "POST",
                data: dataToAPI
            });

            
            if (response && response.status === "OK") {
                const payload = {
                    ...response.data
                }; 
                if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context && response.data.serviceBody.serviceResponse.context.caseId) {
                    payload.caseId = response.data.serviceBody.serviceResponse.context.caseId;
                }
                if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context && response.data.serviceBody.serviceResponse.context.isCasePending) {
                    payload.isCasePending = response.data.serviceBody.serviceResponse.context.isCasePending === "True" ? true : false;;
                }
                if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context &&
                    response.data.serviceBody.serviceResponse.context.contextInfo && response.data.serviceBody.serviceResponse.context.contextInfo.availablePaths) {
                    payload.availablePaths = response.data.serviceBody.serviceResponse.context.contextInfo.availablePaths;
                }
                dispatch({
                    type: FORMER_CUSTOMER_CREATE_CASE_SUCCESS,
                    payload
                });
            } else {
                dispatch({ type: FORMER_CUSTOMER_CREATE_CASE_FAILURE, payload: GENERIC_ERROR_MESSAGE });
            }
        } catch (error) {
            if (error.response && error.response.hasOwnProperty("description")) {
                dispatch({
                    type: FORMER_CUSTOMER_CREATE_CASE_FAILURE,
                    payload: error.response.description
                });
            } else {
                dispatch({
                    type: FORMER_CUSTOMER_CREATE_CASE_FAILURE,
                    payload: GENERIC_ERROR_MESSAGE
                });
            }
        }
    };

export const addressDobUpdate = (data) => async dispatch => {
    dispatch({ type: FORMER_CUSTOMER_ADDRESS_DOB_BEGIN });

    var caseId = data.caseId ? data.caseId : null
    var intent = data.intent ? data.intent : null
    var dob = data.dob ? data.dob : null
    var email = data.email ? data.email : null
    var addressLine1 = data.addressLine1 ? data.addressLine1 : null
    var addressLine2 = data.addressLine2 ? data.addressLine2 : null
    var city = data.city ? data.city : null
    var state = data.state ? data.state : null
    var processStep = "AddressDOB"
    var zipCode = data.zipCode ? data.zipCode : null
    var FirstName = data.FirstName ? data.FirstName : null
    var lastName = data.lastName ? data.lastName : null
    var isOptOut = data.isOptOut ? data.isOptOut : null
    var serviceType = data.serviceType ? data.serviceType : null
    var formerId = data.formerId ? data.formerId : null
    let dataToAPI;


    dataToAPI = {
        caseId,
        intent,
        email,
        dob,
        addressLine1,
        addressLine2,
        city,
        state,
        processStep,
        zipCode,
        serviceType
    };

    if (serviceType === "guest") {
        if (intent === "Delete") {
            dataToAPI.intent = "DeleteOpt";
        }
        Object.assign(dataToAPI,
            { FirstName },
            { lastName }
        );
    } else {
        if (intent === "Delete") {
            if (isOptOut === "Y") {
                Object.assign(dataToAPI,
                    { FirstName },
                    { lastName },
                    { isOptOut },
                )
            } else {
                Object.assign(dataToAPI,
                    { isOptOut },
                    { formerId }
                )
            }
        } else if (intent === "Correct") {
            Object.assign(dataToAPI,
                { formerId }
            )
        }
    }

    try {

        const response = await API({
            url: ENDPOINTS.FORMER_DOWNLOAD_ADDRESS_DOB_DATA,
            method: "POST",
            data: dataToAPI
        });

        if (response && response.status === "OK") {

            const payload = {
                ...response.data
            };
            if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context &&
                response.data.serviceBody.serviceResponse.context.contextInfo && response.data.serviceBody.serviceResponse.context.contextInfo.intent) {
                payload.intent = response.data.serviceBody.serviceResponse.context.contextInfo.intent;
            }
            if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context &&
                response.data.serviceBody.serviceResponse.context.customerInfo) {
                payload.email = response.data.serviceBody.serviceResponse.context.customerInfo.email ? response.data.serviceBody.serviceResponse.context.customerInfo.email : ""
            }
            dispatch({
                type: FORMER_CUSTOMER_ADDRESS_DOB_SUCCESS,
                payload
            });
        } else {
            dispatch({ type: FORMER_CUSTOMER_ADDRESS_DOB_FAILURE, payload: GENERIC_ERROR_MESSAGE });
        }
    } catch (error) {
        if (error.response && error.response.hasOwnProperty("description")) {
            dispatch({
                type: FORMER_CUSTOMER_ADDRESS_DOB_FAILURE,
                payload: error.response.description
            });
        } else {
            dispatch({
                type: FORMER_CUSTOMER_ADDRESS_DOB_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    }
};

export const sendSecurePinToDevice = (emailId, flow, isMobilePage, mobileNo, uuId) => async dispatch => {
    dispatch({ type: CREATE_UUID_BEGIN });
    try {

        let dataToAPI = {};
        if (isMobilePage === "N") {
            dataToAPI = {
                emailId,
                flow,
                isMobilePage,
                uuId
            }
        } else {
            dataToAPI = {
                emailId,
                flow,
                isMobilePage,
                telephoneNumber: mobileNo && mobileNo.length > 0 ? mobileNo : null,
                uuId: uuId && uuId.length > 0 ? uuId : null
            }
        }

        const response = await API({
            url: ENDPOINTS.GUEST_FLOW_MFA_REQUEST_PIN,
            method: "POST",
            data: dataToAPI
        });

        if (response && response.status === "OK") {
            const payload = {
                ...response.data
            };

            if (response.data && response.data.uuid) {
                payload.uuid = response.data.uuid;
            }
            if (response.data && response.data.emailAddress) {
                payload.emailAddress = response.data.emailAddress;
            }
            if (response.data && response.data.telephoneNumber) {
                payload.telephoneNumber = response.data.telephoneNumber;
            }
            dispatch({
                type: CREATE_UUID_SUCCESS,
                payload
            });
        } else {
            dispatch({ type: CREATE_UUID_FAILURE, payload: GENERIC_ERROR_MESSAGE });
        }
    } catch (error) {
        if (error.response && error.response.hasOwnProperty("description")) {
            dispatch({
                type: CREATE_UUID_FAILURE,
                payload: error.response.description
            });
        } else {
            dispatch({
                type: CREATE_UUID_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    }
};

export const validateSecurePin = (pin, flow, uuid) => async dispatch => {
    dispatch({ type: FORMER_VALIDATE_SECURE_PIN_BEGIN });

    try {
        const response = await API({
            method: "POST",
            url: ENDPOINTS.GUEST_FLOW_MFA_VALIDATE_PIN,
            data: {
                securePIN: encryptData(pin),
                uuid,
                flow
            },
            headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json;charset=UTF-8"
            }
        });

        if (response && response.data && parseInt(response.data.status) === 1) {
            const payload = {
                ...response.data
            };
            if (response && response.data && parseInt(response.data.status) === 1 && response.data.emailAddress) {
                var emailData = response.data.emailAddress ? response.data.emailAddress.split("@").pop() : ""
                payload.byPassEmail = emailData
            }
            dispatch({
                type: FORMER_VALIDATE_SECURE_PIN_SUCCESS,
                payload
            });
        } else {
            dispatch({
                type: FORMER_VALIDATE_SECURE_PIN_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    } catch (error) {
        dispatch({
            type: FORMER_VALIDATE_SECURE_PIN_FAILURE,
            payload: error.response.description || GENERIC_ERROR_MESSAGE
        });
    }
};

export const createTimeFrame = (data) => async dispatch => {

    dispatch({ type: CREATE_TIME_FRAME_BEGIN });

    var caseId = data.caseId ? data.caseId : null
    var intent = data.intent ? data.intent : null
    var email = data.email ? data.email : null
    var startDate = data.startDate ? data.startDate : null
    var endDate = data.endDate ? data.endDate : null
    var processStep = "TimeFrame"
    var serviceType = data.serviceType ? data.serviceType : null

    try {
        const response = await API({
            url: ENDPOINTS.FORMER_CREATE_TIME_FRAME,
            method: "POST",
            data: {
                caseId,
                intent,
                email,
                startDate,
                endDate,
                processStep,
                serviceType
            }
        });

        if (response && response.status === "OK") {

            const payload = {
                ...response.data
            };
            if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context &&
                response.data.serviceBody.serviceResponse.context.contextInfo && response.data.serviceBody.serviceResponse.context.contextInfo.availablePaths) {
                payload.availablePaths = response.data.serviceBody.serviceResponse.context.contextInfo.availablePaths;
            }

            dispatch({
                type: CREATE_TIME_FRAME_SUCCESS,
                payload
            });
        } else {
            dispatch({ type: CREATE_TIME_FRAME_FAILURE, payload: GENERIC_ERROR_MESSAGE });
        }
    } catch (error) {
        if (error.response && error.response.hasOwnProperty("description")) {
            dispatch({
                type: CREATE_TIME_FRAME_FAILURE,
                payload: error.response.description
            });
        } else {
            dispatch({
                type: CREATE_TIME_FRAME_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    }
};

export const createFileFormat = (data) => async dispatch => {

    dispatch({ type: CREATE_FILE_FORMAT_BEGIN });

    let formerId;
    if (data.serviceType === "former") {
        formerId = data.formerId ? data.formerId : null
    } else {
        formerId = data.uuid ? data.uuid : null
    }

    var caseId = data.caseId ? data.caseId : null
    var intent = data.intent ? data.intent : null
    var email = data.email ? data.email : null
    var fileFormat = data.fileFormat ? data.fileFormat : null
    var processStep = "SelectFile"
    var downloadType = "AFFIDAVIT"
    var requestType = "DOWNLOAD"
    var requestChannel = "VPD"
    var role = data.serviceType ? data.serviceType : null
    var serviceType = data.serviceType ? data.serviceType : null

    let dataToAPI;
    if (serviceType === "former") {
        dataToAPI = {
            caseId,
            intent,
            email,
            processStep,
            formerId,
            fileFormat,
            downloadType,
            requestType,
            requestChannel,
            role,
            serviceType
        }
    } else {
        dataToAPI = {
            caseId,
            intent,
            email,
            processStep,
            fileFormat,
            downloadType,
            requestType,
            requestChannel,
            role,
            serviceType,
            formerId
        }
    }

    try {
        const response = await API({
            url: ENDPOINTS.FORMER_CREATE_FILE_FORMAT,
            method: "POST",
            data: dataToAPI
        });

        if (response && response.status === "OK") {
            const payload = {
                ...response.data
            };
            if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context &&
                response.data.serviceBody.serviceResponse.context.contextInfo && response.data.serviceBody.serviceResponse.context.contextInfo.availablePaths) {
                payload.availablePaths = response.data.serviceBody.serviceResponse.context.contextInfo.availablePaths;
            }

            dispatch({
                type: CREATE_FILE_FORMAT_SUCCESS,
                payload
            });
        } else {
            dispatch({ type: CREATE_FILE_FORMAT_FAILURE, payload: GENERIC_ERROR_MESSAGE });
        }
    } catch (error) {
        if (error.response && error.response.hasOwnProperty("description")) {
            dispatch({
                type: CREATE_FILE_FORMAT_FAILURE,
                payload: error.response.description
            });
        } else {
            dispatch({
                type: CREATE_TIME_FRAME_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    }
};

export const createDocVerification = (data, checkUser,checkMtn) => async dispatch => {
    dispatch({ type: FORMER_DOC_VERIFICATION_BEGIN });

    var caseId = data.caseId ? data.caseId : null
    var email = data.email ? data.email : null
    var serviceType = data.serviceType ? data.serviceType : ""
    var intent = data.intent ? ((data.intent === "Delete" && serviceType === "guest") ? "DeleteOpt" : data.intent) : null
    var processStep = "DocVerfication"
    var processAction = data.processAction ? data.processAction : null;
    var applicationId = data.applicationId ? data.applicationId : "";
    var isOptOut = data.isOptOut ? data.isOptOut : null;
    var isMitekDoc = data.isMitekDoc ? data.isMitekDoc : null;

    let dataToAPI, url;

    if(checkUser === undefined){ 
        
        url = ENDPOINTS.FORMER_CREATE_DOC_VERIFICATION;

    if (processAction === "Gemalto") {
        if (isOptOut === "Y") {
            dataToAPI = {
                email,
                intent,
                caseId,
                processStep,
                processAction,
                applicationId,
                serviceType,
                isOptOut
            };
        } else {
            dataToAPI = {
                email,
                intent,
                caseId,
                processStep,
                processAction,
                applicationId,
                serviceType
            };
        }
    } else if (processAction === "GetEnforceLink") {
        if (isOptOut === "Y") {
            dataToAPI = {
                email,
                intent,
                caseId,
                processStep,
                processAction,
                serviceType,
                isOptOut,
                isMitekDoc
            };
        } else {
            dataToAPI = {
                email,
                intent,
                caseId,
                processStep,
                processAction,
                serviceType,
                isMitekDoc
            };
        }

    }

    }
    //Agent flow
    else if(checkUser==="agent"){
        dataToAPI = 
            {
                "intent": "ResidencyProof", 
                "processStep": "DocVerfication",
                "identifier": "mtn",
                "value": checkMtn,
                processAction,
                caseId,
                isMitekDoc
             };
            
      url = ENDPOINTS.AGENT_DOCUMENT_VERIFICATION;
    } else { 
        
        dataToAPI = 
            {
                "intent": "ResidencyProof", 
                "processStep": "DocVerfication",
                processAction,
                caseId,
                isMitekDoc
             };
            
      url = ENDPOINTS.ACTIVE_CUSTOMER_DOCUMENT_VERIFICATION;

        

}
        

    

    try {
        

        const response = await API({
            url: url,
            method: "POST",
            data: dataToAPI
        });


        if (response && response.status === "OK") {
            const payload = {
                ...response.data
            };

            if (response.data && response.data.serviceBody && response.data.serviceBody.serviceResponse && response.data.serviceBody.serviceResponse.context &&
                response.data.serviceBody.serviceResponse.context.vpdCCPA && response.data.serviceBody.serviceResponse.context.vpdCCPA.gemaltoLink) {
                payload.gemaltoLink = response.data.serviceBody.serviceResponse.context.vpdCCPA.gemaltoLink;
            }


            dispatch({
                type: FORMER_DOC_VERIFICATION_SUCCESS,
                payload
            });
        } else {
            dispatch({ type: FORMER_DOC_VERIFICATION_FAILURE, payload: GENERIC_ERROR_MESSAGE });
        }
    } catch (error) {
        if (error.response && error.response.hasOwnProperty("description")) {
            dispatch({
                type: FORMER_DOC_VERIFICATION_FAILURE,
                payload: error.response.desription
            });
        } else {
            dispatch({
                type: FORMER_DOC_VERIFICATION_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    }
};

export const formerandGuestCloseCaseId = (data) => async dispatch => {
    dispatch({ type: CLOSE_CASEID_BEGIN });

    try {
        var caseId = data.caseId;
        var intent = data.intent
        var email = data.email
        var processStep = "CloseCase"
        var processAction = "Close"

        let dataToAPI;
        dataToAPI = {
            caseId,
            intent,
            email,
            processStep,
            processAction
        };

        const response = await API({
            url: ENDPOINTS.CLOSE_CASEID + data.serviceType,
            method: "POST",
            data: dataToAPI
        });

        if (response && response.status === "OK") {
            dispatch({
                type: CLOSE_CASEID_SUCCESS,
            });
        } else {
            dispatch({ type: CLOSE_CASEID_FAILURE, payload: GENERIC_ERROR_MESSAGE });
        }
    } catch (error) {
        if (error.response && error.response.hasOwnProperty("description")) {
            dispatch({
                type: CLOSE_CASEID_FAILURE,
                payload: error.response.description
            });
        } else {
            dispatch({
                type: CLOSE_CASEID_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    }
};



export const breadcrumbsLink = (data) => async dispatch => {
    dispatch({ type: BREADCRUMBS_LINK_BEGIN });
    try {
        if (data) {
            dispatch({
                type: BREADCRUMBS_LINK_SUCCESS,
                payload: data
            });
        } else {
            dispatch({ type: BREADCRUMBS_LINK_FAILURE, payload: GENERIC_ERROR_MESSAGE });
        }
    } catch (error) {
        if (error.response && error.response.hasOwnProperty("description")) {
            dispatch({
                type: BREADCRUMBS_LINK_FAILURE,
                payload: error.response.description
            });
        } else {
            dispatch({
                type: BREADCRUMBS_LINK_FAILURE,
                payload: GENERIC_ERROR_MESSAGE
            });
        }
    }
} 
